export enum ETypeBonTravail {
    Interne = 1,
    Externe = 2,
    Chantier = 3
}